import forEach from 'lodash/forEach';

/* SchemaObject Example
* {
*   phoneNumber: {
*      taken: "errorName",
*      default: "Default",
*   },
*
*   default: "String",
* }
*

Example:
export const AuthLoginErrorSchema = schemaError({
  default: "Default error message",
  phoneNumber: {
    taken: "Phone number is taken",
    default: "Some phone error"
  }
})

AuthLoginErrorSchema.get({ phoneNumber: taken })
=> { phoneNumber: "Phone number is taken" }

AuthLoginErrorSchema.get({ phoneNumber: some_other_error_code })
=> { phoneNumber: "Some phone error" }

AuthLoginErrorSchema.get({ key: some_other_error_code })
=> { phoneNumber: "Default error message" }
* */

type SchemaObject = {
  [key: string]:
    | {
        [key: string]: any;
        default: string;
      }
    | string;

  default: string;
};
type ObjectAny = { [key: string]: any };

const schemaError = (schema: SchemaObject) => {
  const get = (err: any) => {
    if (err.message || err.stack) return err;

    const obj: ObjectAny = {};

    forEach(err.data, (value, fieldName) => {
      const schemaField = schema[fieldName];
      const schemaFieldValue = schemaField && schemaField[value];

      if (schemaField) {
        if (schemaFieldValue) {
          obj[fieldName] = schemaFieldValue;
        } else if (typeof schemaField === 'string') {
          obj[fieldName] = schemaField;
        } else if (schemaField.default) {
          obj[fieldName] = schemaField.default;
        }
      } else {
        obj.base = schema.default;
      }
    });

    return obj;
  };

  return { get };
};

export { schemaError };
